import { DEP_LOG_STOCK, DEP_STOCK_CLOSING_URL, POST_WASTAGE_NEW, STOCK_CLOSING_URL, STOCK_TRANSFER_NEW, STOCK_TRANSFER_URL, WASTAGE_BASE_URL, WASTAGE_URL } from "../../CONSTANTS";
import { callGetAxios, callPostApi, callPostAxios, callPutAxios } from "../common/common";

export const addStockClosing = (warehouseID, data) => {
    return callPostAxios(STOCK_CLOSING_URL() + warehouseID, data, "adding Stock Closing");
};
export const addDepStockClosing = (warehouseID, departmentId, data) => {
    return callPostAxios(DEP_STOCK_CLOSING_URL() + warehouseID + '/' + departmentId, data, "adding department Stock Closing");
};


export const addStockTransfer = (data) => {
    return callPostAxios(STOCK_TRANSFER_URL() , data, "adding Stock Closing");
};
export const updateStockTransfer = (data, id) => {
    return callPutAxios(STOCK_TRANSFER_URL() + id , data, "Update Stock Closing");
};
export const getStockTransferDetails = (id) => {
    return callGetAxios(STOCK_TRANSFER_URL() + id , "getting Stock Transfer Details");
};

export const stockTransferApprove = (uuid) => {
    return callPutAxios(STOCK_TRANSFER_URL() + "approved/" + uuid ,  "adding Stock Closing");
};
export const stockTransferCancel = (uuid) => {
    return callPutAxios(STOCK_TRANSFER_URL() + "cancel/" + uuid ,  "adding Stock Closing");
};

export const getStockTransferList = (data,) => {
    return callPostAxios(STOCK_TRANSFER_URL()+"getAllRecords",data, "getting Stock Closing List");
}

export const logStockTransferHistory = (id) => {
    return callGetAxios(STOCK_TRANSFER_NEW + "getStockTransferHistory/" + id, "logStockClosingHistory");
};

export const addStockApprove = (uuid) => {
    return callPutAxios(STOCK_TRANSFER_URL() + "approved/" + uuid ,  "adding Stock Closing");
};

export const getStockClosingList = (warehouseID) => {
    return callGetAxios(STOCK_CLOSING_URL() +"warehouseList/"+ warehouseID, "getting Stock Closing List");
};
export const getDepStockClosingList = (warehouseID,departmentId) => {
    return callGetAxios(DEP_STOCK_CLOSING_URL() +"warehouseList/"+ warehouseID+"/"+departmentId, "getting Stock Closing List");
};

export const getStockClosingRecordDetails = (warehouseID, stockID) => {
    return callGetAxios(STOCK_CLOSING_URL() + warehouseID + "/" + stockID, "getting Stock Closing Details");
};
export const getDepStockClosingRecordDetails = (uuid, id) => {
    return callGetAxios(DEP_STOCK_CLOSING_URL() + uuid + "/" + id, "getting Stock Closing Details");
};
export const logStockClosingHistory = (id) => {
    return callGetAxios(STOCK_CLOSING_URL() + "getStockClosingHistory/" + id, "logStockClosingHistory");
};
export const logDepStockClosingHistory = (id) => {
    return callGetAxios(DEP_LOG_STOCK() + "getDepartmentStockClosingHistory/" + id, "logStockClosingHistory");
};


export const addWastage = (warehouseID, data) => {
    return callPostAxios(POST_WASTAGE_NEW + warehouseID, data, "adding Wastage");
};

export const getWastageList = (warehouseID) => {
    return callGetAxios(WASTAGE_URL() + warehouseID, "getting Wastage List");
};

export const getWastageRecordDetails = (warehouseID, getWastageRecordDetails) => {
    return callGetAxios(WASTAGE_BASE_URL() + warehouseID + "/" + getWastageRecordDetails, "getting Stock Closing Details");
};
export const logWastageClosingHistory = (id) => {
    return callGetAxios(WASTAGE_BASE_URL() + "getWastageHistory/" + id, "getWastageHistory");
};

export const getTransferDetails = (id,data) => {
    return callGetAxios(STOCK_TRANSFER_URL() + id, 'Item Price List Report');
};